import Marquee from "react-fast-marquee";

const ITEMS = [
  "Анализ пропорций",
  "Маска Марквардта",
  "Золотое сечение",
  "Виртуальная примерка",
  "Дизайн Про",
];

export const EditorialMarquee = () => (
  <div className="border-y border-white/5 bg-[#0A0A0A] py-10" data-testid="editorial-marquee">
    <Marquee speed={32} gradient={false} pauseOnHover>
      {ITEMS.map((item) => (
        <span key={item} className="mx-16 flex items-center gap-32">
          <span className="font-cormorant text-4xl font-light italic text-[#3A3A37] md:text-6xl">
            {item}
          </span>
          <span className="font-cormorant text-2xl italic text-[#C2A878]/40">·</span>
        </span>
      ))}
    </Marquee>
  </div>
);
